<template>
  <span :class="[role.toLowerCase(), 'role-tag']">
    <i/>
    {{ ROLE_MAP[role] }}
  </span>
</template>

<script>
import { ROLE_MAP } from '@/common/constant/qz';

export default {
  name: 'RolesTag',
  props: {
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      ROLE_MAP
    }
  }
}
</script>

<style scoped lang="less">
.role-tag {
  width: 76px;
  display: flex;
  height: 28px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  
  i {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  
  &.teacher {
    border: 0.5px solid #B8862B;
    color: #B8862B;
    background: #FFF3DC;
    
    i {
      background: url("../images/techer.png") center / cover no-repeat;
    }
  }
  
  &.admin {
    border: 0.5px solid #FF6720;
    color: #FF6720;
    background: #FFF0E9;
    
    i {
      background: url("../images/admin.png") center / cover no-repeat;
    }
  }
  
  &.student {
    border: 0.5px solid #3491FA;
    color: #3491FA;
    background: #F0F7FF;
    
    i {
      background: url("../images/student.png") center / cover no-repeat;
    }
  }
}
</style>